import {SELECTED_INDEX} from './selectedTypes'

export const selectedIndex = index => {
    return {
        type: SELECTED_INDEX,
        payload: index
    }
}

export const selectNewIndex = (index) => {
    return (dispatch) => {
        dispatch(selectedIndex(index))
    }

}